<template>
  <div id="contenedor-licitacion-junta-aclaraciones-asistio">
    <v-form v-model="formularioValido" ref="asistioJuntaAclaraciones">
      <v-switch v-model="asistio" @change="quitarAgregar" inset> </v-switch>
    </v-form>
  </div>
</template>

<script>
import AGREGAR_LICITACION_JUNTA_ACLARACIONES from '@/graphql/mutations/administracion/licitaciones/juntaaclaraciones/agregarLicitacionJuntaAclaracion.gql';
import REMOVER_LICITACION_JUNTA_ACLARACIONES from '@/graphql/mutations/administracion/licitaciones/juntaaclaraciones/removerLicitacionJuntaAclaracion.gql';
import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';

export default {
  name: 'LicitacionJuntaAclaracionesAsistio',
  props: {
    participanteJuntaAclaraciones: Object,
  },
  data() {
    return {
      formularioValido: false,
      asistio: null,
    };
  },

  methods: {
    quitarAgregar() {
      if (this.asistio === false) {
        this.eliminarLicitacionJuntaAclaraciones();
      } else {
        this.agregarLicitacionJuntaAclaracion();
      }
    },
    setAsistio() {
      if (!this.participanteJuntaAclaraciones.juntaAclaraciones) return;
      this.asistio = this.participanteJuntaAclaraciones.juntaAclaraciones.asistio;
    },

    async agregarLicitacionJuntaAclaracion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: AGREGAR_LICITACION_JUNTA_ACLARACIONES,
          variables: {
            idLicitacion: this.participanteJuntaAclaraciones.idLicitacion,
            idParticipante: this.participanteJuntaAclaraciones.id,
            asistio: this.asistio,
          },
          update: (store, { data: { agregarLicitacionJuntaAclaracion } }) => {
            const data = store.readQuery({
              query: LICITACION_PARTICIPANTES,
              variables: {
                idLicitacion: this.participanteJuntaAclaraciones.idLicitacion,
              },
            });
            const participante = data.licitacionParticipantes.find(
              (participanteJunta) => participanteJunta.id === this.participanteJuntaAclaraciones.id,
            );
            participante.juntaAclaraciones = agregarLicitacionJuntaAclaracion;
            store.writeQuery({ query: LICITACION_PARTICIPANTES, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
    async eliminarLicitacionJuntaAclaraciones() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: REMOVER_LICITACION_JUNTA_ACLARACIONES,
          variables: {
            idParticipante: this.participanteJuntaAclaraciones.id,
          },
          update: (store) => {
            const data = store.readQuery({
              query: LICITACION_PARTICIPANTES,
              variables: {
                idLicitacion: this.participanteJuntaAclaraciones.idLicitacion,
              },
            });
            const participante = data.licitacionParticipantes.find(
              (participanteJunta) => participanteJunta.id === this.participanteJuntaAclaraciones.id,
            );
            participante.juntaAclaraciones = null;
            store.writeQuery({ query: LICITACION_PARTICIPANTES, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
  },
  mounted() {
    this.setAsistio();
  },
};
</script>

<style>
</style>
